import React, { useEffect } from 'react'
import { useUserNames } from '../../contexts/userNames'

const NameTag = ({ userToken, onUpdate, alias='', ...props }) => {
  const { setAlias, getAlias } = useUserNames()
  const cachedAlias = getAlias(userToken)

  const onClick = () => {
    const newAlias = prompt('Enter new alias', alias || '')
    if (!newAlias) {
      return
    }
    setAlias(userToken, newAlias)
    onUpdate(userToken, newAlias)
  }

  return (
    <span onClick={onClick} {...props}>
      {alias || cachedAlias}
    </span>
  )
}

export default NameTag
